import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../Hooks/AuthContext";
import { get, unAuthGet } from "../../Services/api.service";
import { Paths } from "../../Services/EndPoints";
import { useDispatch } from "react-redux";
import { setPrescribeData } from "../../Redux/Actions";
import { useNotification } from "../../Components/CustomStatus/UseNotification";
import { isEmpty } from "lodash";
import { TitleHeaderSkeleton } from "../../Utils/Mock";
import SkeletonUI from "../../Components/Skeletons";
import { useQuery } from "../../Hooks/useQuery";
export default function CheckOrder({ referrer }) {
  const { user } = useAuth();
  const { id } = useParams();
  const query = useQuery();
  const session = sessionStorage.getItem("sessionToken") || null;
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const fetchPresOrder = (data) => {
    if (user?.number === data?.mobileNumber) {
      setIsLoading(true);
      get(Paths?.prc_to_cart + `/${data?.number}`)
        .then((res) => {
          if (res?.statusCode === 204) {
            openToast({
              content: res.data?.message || "Prescription is already in cart.",
              type: "success",
            });
          }
          navigate("/");
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    } else {
      dispatch(setPrescribeData(data));
      navigate("/auth/login?id=prescribe");
    }
  };

  const fetchCoData = (data) => {
    setIsLoading(true);
    unAuthGet(Paths?.co_to_cart + `/${data?.number}`)
      .then((res) => {
        navigate("/cart-products");
        if (res?.status === "FAILED") {
          openToast({
            content: res?.message || "Custom Order is already in cart.",
            type: "warning",
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (session !== null) {
      const fetchData = async (type) => {
        setIsLoading(true);
        try {
          const res = await unAuthGet(
            Paths?.get_prc_data + `?number=${id}&type=${type}`
          );
          if (!isEmpty(res?.data)) {
            if (query.get("ref") === "WA") {
              window.location.href = res?.data?.link;
            } else {
              if (type === "prescription") {
                fetchPresOrder(res?.data);
              } else if (referrer === "customOrder") {
                fetchCoData(res?.data);
              } else {
                if (isEmpty(user)) {
                  navigate("/auth/login", {
                    state: {
                      from: "/cart-products",
                    },
                  });
                }
              }
            }
          } else {
            openToast({
              content: res?.message || "Data is not available.",
              type: "warning",
            });
          }
        } catch (err) {
          openToast({
            content: err?.response?.data?.message || "Something went wrong.",
            type: "error",
          });
        } finally {
          setIsLoading(false);
        }
      };

      if (referrer === "prescribeOrder") {
        fetchData("prescription");
      } else if (referrer === "customOrder") {
        fetchData("customorder");
      } else {
        fetchData("acart");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, query, referrer, session, user]);

  return (
    <React.Fragment>
      {isLoading && (
        <>
          <TitleHeaderSkeleton />
          <div className="pt-5">
            <div className=" py-1 px-3 ">
              <SkeletonUI
                cardId="button"
                noOfButtons={1}
                className={"w-full h-12 rounded-md"}
              />
            </div>
            {Array.from({ length: 4 }).map((_, index) => (
              <div className="px-3 py-1" key={index}>
                <SkeletonUI cardId={"horizontal-card-skeleton"} />
              </div>
            ))}
          </div>
        </>
      )}
    </React.Fragment>
  );
}
